// Worked examples for the Sprint Forecast. Illustrative: invented velocities.
// Addressable as #example=<id>.

export const EXAMPLES = [
  {
    id: "steady-team",
    name: "Steady team, six sprints",
    description: "Points per sprint and a backlog range. Illustrative.",
    state: { history: "28 31 25 34 30 27", remaining: { low: 150, high: 210 }, unit: "points", spread: "typical", sprintWeeks: 2 },
  },
  {
    id: "new-team",
    name: "New team, three sprints",
    description: "Only three sprints of history: the forecast is wide on purpose. Illustrative.",
    state: { history: "18 26 21", remaining: { low: 120, high: 160 }, unit: "points", spread: "typical", sprintWeeks: 2 },
  },
  {
    id: "agent-team",
    name: "Agentic coding team, weekly",
    description: "Items merged per week by coding agents with human review: high and uneven. Illustrative.",
    state: { history: "42 61 38 70 55 47 66", remaining: { low: 300, high: 450 }, unit: "items", spread: "volatile", sprintWeeks: 1 },
  },
];

export function exampleById(id) {
  return EXAMPLES.find((e) => e.id === id) ?? null;
}
